import { Model } from '../parents/model';

export class SettingsModel extends Model {
  static ATTR_ARTICLE_COMMENTS_ALLOWED = 'article_comments_allowed';

  static ATTR_PRICE_LISTS_PREFERENCE = 'price_lists_preference';

  static ATTR_FIRST_DAY_OF_WEEK = 'first_day_of_week';

  static ATTR_DAYS_OFF = 'days_off';

  static ATTR_ROUNDING_METHOD = 'rounding_method';

  static ATTR_TIMEZONE = 'timezone';

  static ATTR_SET_ORDER_STATE_AFTER_ORDER_PRINT = 'set_order_state_after_order_print';

  static ATTR_CHANGE_ORDER_STATE_AFTER_ORDER_PRINT_IDS = 'change_order_state_after_order_print_ids';

  get articleCommentsAllowed() {
    return this.attributes[SettingsModel.ATTR_ARTICLE_COMMENTS_ALLOWED];
  }

  get priceListsPreference() {
    return this.attributes[SettingsModel.ATTR_PRICE_LISTS_PREFERENCE];
  }

  get firstDayOfWeek() {
    return this.attributes[SettingsModel.ATTR_FIRST_DAY_OF_WEEK];
  }

  get daysOff() {
    return this.attributes[SettingsModel.ATTR_DAYS_OFF];
  }

  get roundingMethod() {
    return this.attributes[SettingsModel.ATTR_ROUNDING_METHOD];
  }

  get timezone() {
    return this.attributes[SettingsModel.ATTR_TIMEZONE];
  }

  get setOrderStateAfterOrderPrint() {
    return this.attributes[SettingsModel.ATTR_SET_ORDER_STATE_AFTER_ORDER_PRINT];
  }

  get changeOrderStateAfterOrderPrintIds() {
    return this.attributes[SettingsModel.ATTR_CHANGE_ORDER_STATE_AFTER_ORDER_PRINT_IDS];
  }
}
